import { motion } from "framer-motion";

export default function LoadingScreen() {
  return (
    <motion.div
      data-testid="loading-screen"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center"
      style={{ background: "#050505" }}
    >
      {/* LOGO */}
      <motion.img
        data-testid="loading-logo"
        src="/logo/elite-eventz-logo.png"
        alt="Elite Eventz"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
        className="w-56 sm:w-72 h-auto mb-2 select-none"
        draggable={false}
      />

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5, duration: 0.9 }}
        className="mt-2 text-xs sm:text-sm text-neutral-300 tracking-[0.32em] uppercase"
      >
        Crafting Experiences · Creating Memories
      </motion.p>

      <div className="mt-10 w-64 loading-bar" />
    </motion.div>
  );
}
